export function handleResponse(response) {
    return response;
}
